"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var omit_1 = tslib_1.__importDefault(require("lodash/omit"));
var ConfigurationPanelContent_1 = tslib_1.__importDefault(require("./ConfigurationPanelContent"));
var UnsupportedProperties_1 = tslib_1.__importDefault(require("../configurationControls/UnsupportedProperties"));
var UnsupportedConfigurationPanel = /** @class */ (function (_super) {
    tslib_1.__extends(UnsupportedConfigurationPanel, _super);
    function UnsupportedConfigurationPanel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UnsupportedConfigurationPanel.prototype.componentDidMount = function () {
        this.props.pushData({
            properties: omit_1.default(this.props.properties, "controls"),
            references: null,
            ignoreUndoRedo: true,
        });
    };
    UnsupportedConfigurationPanel.prototype.isControlDisabled = function () {
        return true;
    };
    UnsupportedConfigurationPanel.prototype.renderConfigurationPanel = function () {
        return react_1.default.createElement(UnsupportedProperties_1.default, null);
    };
    return UnsupportedConfigurationPanel;
}(ConfigurationPanelContent_1.default));
exports.default = UnsupportedConfigurationPanel;
//# sourceMappingURL=UnsupportedConfigurationPanel.js.map